module.exports = __webpack_public_path__ + "assets/icon-project-available-to-others-selected.35e5afae.svg";